module.exports = __webpack_public_path__ + "media/images/grubhub-e8052ad9842005cff4537f93b6551b7a.svg";